import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { PedidoService } from '../../../services/pedido.service';

@Component({
  selector: 'app-pedidos-sin-sala',
  templateUrl: './pedidos-sin-sala.component.html',
  styleUrls: ['./pedidos-sin-sala.component.css'],
  providers:[
    PedidoService
  ]
})
export class PedidosSinSalaComponent implements OnInit {
  public loading:Boolean;
  @Output() sendPedido=  new EventEmitter();
  public pedidos:Array<any>;


  constructor(
    public bsModalRef: BsModalRef,
    private pedidoService:PedidoService

  ) { 
    this.pedidos = [];
  }

  ngOnInit() {
    this.loading = true;
    let p1 =this.getPedidos();
    Promise.all([p1]).then(
      res=>this.loading = false,
      err=>this.loading = false
    );
  }

  getPedidos() {
    return new Promise((resolve, reject) => {this.pedidoService.getAll("?embed=detalle?embed=producto&status=I&sort=-id&mesa_id=0").subscribe(
        res => {
          this.pedidos = res.data;
          resolve();
        },
        err => {
          this.pedidos = [];
          reject(err);
        }
      );
    });

  }

  onsendPedido(pedido) {
		//envía de objecto usuario
		this.sendPedido.emit(pedido.id);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/pedidos-sin-sala/pedidos-sin-sala.component.ts